import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";

import css from "./ErrorHint.module.scss";

export type ErrorHintProps = Props;

export function ErrorHint({ className, ...props}: Props) {
  return <span {...classNames(className, css.ErrorHint)} {...props} />
}
